import { render, staticRenderFns } from "./gl-brand-logo.vue?vue&type=template&id=4cc212cb"
import script from "./gl-brand-logo.vue?vue&type=script&lang=js"
export * from "./gl-brand-logo.vue?vue&type=script&lang=js"
import style0 from "./gl-brand-logo.vue?vue&type=style&index=0&id=4cc212cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports